import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import Img from "gatsby-image";
import React, { useEffect, useState } from 'react';
// import useSessionState from '../../../shared/hooks/useSessionState';
import ProductService from '../../../shared/services/products';
import SessionService from '../../../shared/services/session';
import './productDetailSection.scss';

const renderDrops = (drops, activeDrops) => {

  let nodeArray = []
  for (let index = 0; index < Number(drops); index++) {
    nodeArray.push(
      <svg className="f-card-product-resena-drop" key={index} viewBox="0 0 23.36 34.747">
        <path className={index < Number(activeDrops) ? "f-drop f-drop--active" : "f-drop"} d="M16.68,36.747A11.919,11.919,0,0,1,5,24.586C5,15.465,16.68,2,16.68,2S28.36,15.465,28.36,24.586A11.919,11.919,0,0,1,16.68,36.747Z" transform="translate(-5 -2)" />
      </svg>
    );
  }
  return nodeArray;
}

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <p className="f-card-product-description f-p" >{children}</p>
  }
}

const ProductDetailSection = props => {

  const [localLikes, setlocalLikes] = useState([])
  const [isFakeLiked, setisFakeLiked] = useState(false)
  const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
  const [likeValue, setlikeValue] = useState(null)

  const formatNumber = (num) => {
    if (num > 999999) {
      return parseInt(num / 1000000, 10).toString() + 'M'
    } else if (num > 999) {
      return parseInt(num / 1000, 10).toString() + 'K'
    } else {
      return num
    }
  }

  const isLiked = (idProduct) => {
    let i
    for (i = 0; i < localLikes.length; i++) {
      if (localLikes[i] === idProduct) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    handleLoadLikes();
    setlocalLikes(localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null ? JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS')) : [])
  }, [])

  const handleLoadLikes = () => {
    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ProductService.getAnomLikes().then(res => {

        // setlistLikes(res.data)
        setlikeValue(res.data.filter(item => { if (item.idCMS === props.idProduct) { return item.like } })[0].like)

      }).catch(e => console.log(e))
    } else {
      localStorage.removeItem('LOCAL_LIKES_PRODUCTS');

      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ProductService.getAuthLikes(config).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          // console.log(res.data[index]);

          if (res.data[index].userLike) {
            if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
              const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
              localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS)))
              setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
            } else {
              localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([res.data[index].idCMS]))
              setlocalLikes([res.data[index].idCMS])
            }
          }
        }
        setlikeValue(res.data.filter(item => { if (item.idCMS === props.idProduct) { return item.like } })[0].like)
      }).catch(e => console.log(e));
    }
  }

  const handleUnLike = () => {
    const payload = {
      type: "PRODUCTO",
      idCMS: props.idProduct,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {

      ProductService.setAnomUnLikes(payload).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
          localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.filter(item => item !== props.idProduct)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.idProduct))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ProductService.setAuthUnLikes(payload, config).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
          localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.filter(item => item !== props.idProduct)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.idProduct))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    }
  }

  const handleLike = () => {
    const payload = {
      type: "PRODUCTO",
      idCMS: props.idProduct,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ProductService.setAnomLikes(payload).then(res => {
        if (res.status === 200) {
          if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(props.idProduct)))
            setlocalLikes(copyLocalLikes.concat(props.idProduct))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([props.idProduct]))
            setlocalLikes([props.idProduct])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));

    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }
      ProductService.setAuthLikes(payload, config).then(res => {
        if (res.status === 200) {
          if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(props.idProduct)))
            setlocalLikes(copyLocalLikes.concat(props.idProduct))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([props.idProduct]))
            setlocalLikes([props.idProduct])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    }
  }

  const newSlug = props.slug.substring(props.slug.lastIndexOf('/') + 1);

  return (
    <section className="f-product-detail-section">
      <div className="f-product-detail-section-primary" >
        <label className={`f-${newSlug} f-mobile-title`} >{props.title}</label>
        <div className="image" >
          {props.isFreeSamples && props.imagenProducto !== null ?
            <Img fluid={props.imagenProducto.fluid} />
            :
            <Img fluid={props.imagenProducto && props.imagenProducto.fluid} alt={props.imagenProducto && props.imagenProducto.description} />
          }
          {!props.isFreeSamples ?
            <div className="f-likes-container">
              {isLiked(props.idProduct) ?
                <div className="f-icon-heart" onClick={() => handleUnLike()}></div>
                :
                <div className="f-icon-heart-gray" onClick={() => handleLike()}></div>
              }
              <label className="f-count-likes">{formatNumber(isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue)}</label>
            </div>
            :
            <></>
          }
        </div>
        <div className="description" >
          <h1 className={`f-${newSlug} f-card-product-title f-h1`} >{props.title}</h1>
          {props.descripcion && documentToReactComponents(props.descripcion.json, options)}
          <div className="f-card-product-resena f-p" >
            {props.nivelIncontinencia && documentToReactComponents(props.nivelIncontinencia.json)}
            <div>{props.numeroGotas && renderDrops(props.numeroGotas, props.numeroGotasLlenas)}</div>
          </div>
          {props.atributes && <div className="f-card-product-atributes" >
            {props.atributes.map((attr, key) =>
              <div className="f-atribute" key={key} >
                <img src={attr.imagenDelSello.file.url} alt={attr.imagenDelSello.description} />
                {documentToReactComponents(attr.descripcionDelSello.json)}
              </div>
            )}
          </div>
          }
          {props.sizes &&
            <div className="f-card-product-sizes" >
              <h4 className="f-title" >{props.lbtalla}</h4>
              <div className="f-sizes" >
                {props.sizes.map((size, key) => {
                  const isSizeSelected = props.samples.find(sample => sample.size === size) || props.samplesSent.find(s => s.size === size && s.id === props.idProduct);
                  return <div
                    className={`f-sizes-size ${size === props.sizeSelected ? `f-sizes-size-select ${size.toLowerCase()}` : isSizeSelected ? 'f-sizes-size-selected' : ''}`}
                    onClick={() => !isSizeSelected && props.selectSize(size)} key={key} >{size}
                  </div>
                })}
              </div>
            </div>
          }
        </div>
      </div>
      {props.beneficios}
      {props.products}
    </section>
  )
}

export default ProductDetailSection;